import { useSelector } from 'react-redux';

export default function useProbeTree(credentialId) {
  const probe = useSelector((state: any) => state.probe);
  const probeResponse = probe[credentialId];
  let databases = [],
    probeDataFlat = [];

  if (probeResponse?.nestedProbeTree) {
    databases = probeResponse?.nestedProbeTree;
  }

  if (probeResponse?.tree) {
    probeDataFlat = probeResponse.tree;
  }

  return {
    databases,
    probeDataFlat,
    error: probeResponse?.error || null,
  };
}
